import { Box } from "@chakra-ui/react";
import { MotionConfig } from "framer-motion";
import { AboutSection } from "../components/AboutSection";
import { ChapterRail } from "../components/ChapterRail";
import { ContactSection } from "../components/ContactSection";
import { DeliverySection } from "../components/DeliverySection";
import { ExperienceSection } from "../components/ExperienceSection";
import { HeroSection } from "../components/HeroSection";
import { Navbar } from "../components/Navbar";
import { ProjectsSection } from "../components/ProjectsSection";
import { ScrollProgress } from "../components/ScrollProgress";
import { StatsBand } from "../components/StatsBand";

export function Home() {
  return (
    <MotionConfig reducedMotion="user">
      <Box bg="graphite.950">
        <ScrollProgress />
        <Navbar />
        <ChapterRail />
        <main>
          <HeroSection />
          <StatsBand />
          <DeliverySection />
          <ExperienceSection />
          <ProjectsSection />
          <AboutSection />
          <ContactSection />
        </main>
      </Box>
    </MotionConfig>
  );
}
